import React from 'react'
import { getImages } from '../Const';
import { Link } from 'react-router-dom';

const ViewDocuSignModal = ({ close, docusignData }) => {
    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title text-uppercase" id="staticBackdropLabel">View DocuSign</h1>
                <button className="sm-box-close" type="button" onClick={() => {
                    close();
                }}><i className="fa-solid fa-xmark"></i></button>
            </div>
            <div className="modal-body p-0">
                <div className='custom-form form-style2'>
                    <div className='d-flex align-items-center justify-content-between docusign-modal-top'>
                        <div>
                            <img src={getImages('url.png')} />
                        </div>
                        <div>
                            <Link 
                                // to={`/edit-docuSign`}
                                to={"/edit-docuSign?accutrade_id=" + docusignData.accutrade_id}
                                // state={{ documentData: videDocData }}
                                className="blue-transparent-btn d-inline-block dark-transparent-btn text-uppercase docusign-modal-btn me-4" type="button">
                                <span className='d-inline-block me-4'><img src={getImages('edit-anticon.png')} /></span>
                                Edit Document
                            </Link>
                            <button className="blue-btn docusign-modal-btn text-center text-uppercase pe-5" type="button">
                                <span className='d-inline me-5'><img src={getImages('share-icon.png')} /></span>
                                Send
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mt-4'>
                    <img src={getImages('View-DocuSign.jpg')} />
                </div>
            </div>
        </>
    )
}

export default ViewDocuSignModal